import Head from "next/head";

type LinkTag = {
  rel?: string;
  href: string;
  key?: string;
};

type MetaManagerProps = {
  title?: string;
  description?: string;
  links?: LinkTag[];
  url?: string;
  image?: string;
};

export default function MetaManager({ title, description, links, url, image }: MetaManagerProps) {
  return (
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      {
        title ? (
          <>
            <title>{title} | Lutely</title>
            <meta property="og:title" content={`${title} | Lutely`} />
            <meta property="twitter:title" content={`${title} | Lutely`} />
          </>
        )
        :
        <title>Lutely</title>
      }
      {
        description && (
          <>
            <meta name="description" content={description} />
            <meta property="og:description" content={description} />
            <meta property="twitter:description" content={description} />
          </>
        )
      }

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Lutely" />
      {
        url && (
          <>
            <meta property="og:url" content={url} />
            <meta property="twitter:url" content={url} />
          </>
        )
      }
      {
        image && (
          <>
            <meta property="og:image" content={image} />
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:image" content={image} />
          </>
        )
      }
      {
        links && links.map((link: any) => (
          <link
            rel={link.rel || "canonical"}
            href={link.href}
            key={link.key || "canonical"}
          />
        ))
      }
    </Head>
  )
}